export const buildVoiceNoteDisplayName = ({ date, time = '' } = {}) => {
  const captureDate = date instanceof Date && !Number.isNaN(date.getTime()) ? date : new Date();
  const dateLabel = captureDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const [hoursText = '', minutesText = ''] = String(time || '').split(':');
  const hours = Number(hoursText);
  const minutes = Number(minutesText);
  if (!Number.isInteger(hours) || hours < 0 || hours > 23 || !Number.isInteger(minutes) || minutes < 0 || minutes > 59) {
    return `Voice note · ${dateLabel}`;
  }
  const timeDate = new Date(captureDate);
  timeDate.setHours(hours, minutes, 0, 0);
  const timeLabel = timeDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  return `Voice note · ${dateLabel} at ${timeLabel}`;
};
